import React, { useEffect, useState } from "react";
import { Modal, Paper, Typography, Button, Fade, TextField, Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        padding: theme.spacing(6),
        maxWidth: 600,
        width: '100%'
    },
    buttonContainer: {
        marginTop: theme.spacing(4),
        display: 'flex',
        justifyContent: 'space-between'
    },
    button: {
        marginTop: theme.spacing(2)
    },
    boldText: {
        fontWeight: 'bold',
        fontSize: '1rem'
    }
}));

interface NoteModalProps {
    open: boolean;
    handleClose: () => void;
    handleSave: (note: string) => void;
    handleNoteGetInitialValue: () => string;
    isEditable: boolean;
}

const NoteModal: React.FC<NoteModalProps> = ({ open, handleClose, handleSave, handleNoteGetInitialValue, isEditable }) => {
    const classes = useStyles();
    const [note, setNote] = useState<string>("");


    const handleNoteChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNote(event.target.value);
    };

    const onSave = () => {
        handleSave(note);
        handleClose();
    };

    const handleCancel = () => {
        setNote("");
        handleClose();
    };

    useEffect(() => {
        setNote(handleNoteGetInitialValue());
    }, [open]);

    return (
        <Modal
            aria-labelledby="note-modal-title"
            aria-describedby="note-modal-description"
            className={classes.modal}
            open={open}
            onClose={handleCancel}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Paper className={classes.paper}>
                    <Typography id="note-modal-title" className={classes.boldText}>
                        Napomena
                    </Typography>
                    <TextField
                        id="note"
                        multiline
                        fullWidth
                        rows={4}
                        value={note}
                        onChange={handleNoteChange}
                        error={(note && note.length > 1000) ? true : false}
                        helperText={(note && note.length > 1000) ? "Postignut je maksimalan broj znakova!" : ""}
                        disabled={!isEditable}
                        variant="outlined"
                    />
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" color="primary" onClick={handleCancel} className={classes.button}>
                            Odustani
                        </Button>
                        {isEditable && (
                            <Button variant="contained" color="primary" onClick={onSave} className={classes.button} disabled={note.length > 1000}>
                                Spremi
                            </Button>
                        )}
                    </div>
                </Paper>
            </Fade>
        </Modal>
    );
};

export default NoteModal;
